import angular from 'angular';
import pmdTabs from "./directives/tabs/pmdTabs";
import pmdPickers from "./directives/pickers/pmdPickers";
import pmdDropdown from "./directives/pickers/pmdDropdown";
import pmdAlert from './directives/toasts/pmdAlert';
import pmdAccordion from "./directives/accordion/pmdAccordion";
import pmdProgress from "./directives/progress/pmdProgress";
import pmdDialog from "./directives/dialogs/pmdDialog";
import pmdTooltip from "./directives/others/pmdTooltip";
import pmdAvatar from "./directives/others/pmdAvatar";
import pmdCalendar from "./directives/others/pmdCalendar";
import pmdSelect from "./directives/inputs/pmdSelect";
import pmdInfiniteScroll from "./directives/inputs/pmdInfiniteScroll";
import asNumber from "./directives/inputs/asNumber";
import pmdScrollbar from "./directives/others/pmdScrollbar";
import pmdSlider from "./directives/others/pmdSlider";

export default angular.module('app.interface.directives', [pmdTabs, pmdPickers, pmdDropdown, pmdAlert, pmdAccordion, pmdProgress, pmdDialog, pmdTooltip, pmdAvatar, pmdCalendar, pmdSelect, pmdInfiniteScroll, asNumber, pmdScrollbar, pmdSlider])
  .run(['$rootScope', ($rootScope) => {
  $rootScope.uiBase = {
    name: 'Børk',
    description: 'Streamline MD&B Base Template in AngularJS',
    version: '1.0.3'
  };
  }])
  .name;
